import React from 'react';
import { Create as RaCreate } from 'react-admin';
import { ViewTitle } from './ViewTitle';
export const Create = props => (React.createElement(React.Fragment, null,
    React.createElement(ViewTitle, null),
    React.createElement(RaCreate, Object.assign({}, props))));
//# sourceMappingURL=Create.js.map